/**
 * @generated SignedSource<<ce5436f15b68d3b41938ee0e72a1a14d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FileType = "DOC" | "DOCX" | "PDF" | "PPT" | "PPTX" | "XLS" | "XLSX";
export type useWorkspaceSignalEditAddFileMutation$variables = {
  fileIds: ReadonlyArray<string>;
  signalWorkspaceId: string;
};
export type useWorkspaceSignalEditAddFileMutation$data = {
  readonly signalWorkspace: {
    readonly addFiles: {
      readonly descriptionFiles: ReadonlyArray<{
        readonly id: string;
        readonly name: string | null;
        readonly type: FileType | null;
        readonly url: string;
      }>;
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"WorkspaceSignalEditMainEditedInfo_Signal">;
    };
  };
};
export type useWorkspaceSignalEditAddFileMutation = {
  response: useWorkspaceSignalEditAddFileMutation$data;
  variables: useWorkspaceSignalEditAddFileMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fileIds"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "signalWorkspaceId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "signalWorkspaceId"
  }
],
v3 = [
  {
    "kind": "Variable",
    "name": "fileIds",
    "variableName": "fileIds"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "File",
  "kind": "LinkedField",
  "name": "descriptionFiles",
  "plural": true,
  "selections": [
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    (v5/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useWorkspaceSignalEditAddFileMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "SignalWorkspaceMutation",
        "kind": "LinkedField",
        "name": "signalWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "SignalWorkspace",
            "kind": "LinkedField",
            "name": "addFiles",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "WorkspaceSignalEditMainEditedInfo_Signal"
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useWorkspaceSignalEditAddFileMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "SignalWorkspaceMutation",
        "kind": "LinkedField",
        "name": "signalWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "SignalWorkspace",
            "kind": "LinkedField",
            "name": "addFiles",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "updatedBy",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UnzonedDate",
                "kind": "LinkedField",
                "name": "updatedAtDate",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isoString",
                        "storageKey": null
                      }
                    ],
                    "type": "Date",
                    "abstractKey": "__isDate"
                  }
                ],
                "storageKey": null
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9d992b8dbd8471ea1d78fac402538e5d",
    "id": null,
    "metadata": {},
    "name": "useWorkspaceSignalEditAddFileMutation",
    "operationKind": "mutation",
    "text": "mutation useWorkspaceSignalEditAddFileMutation(\n  $signalWorkspaceId: ID!\n  $fileIds: [ID!]!\n) {\n  signalWorkspace(id: $signalWorkspaceId) {\n    addFiles(fileIds: $fileIds) {\n      id\n      ...WorkspaceSignalEditMainEditedInfo_Signal\n      descriptionFiles {\n        id\n        type\n        url\n        name\n      }\n    }\n  }\n}\n\nfragment FormattedDate on Date {\n  __isDate: __typename\n  ...useFormattedDate\n}\n\nfragment WorkspaceSignalEditMainEditedInfo_Signal on SignalWorkspace {\n  updatedBy {\n    id\n    name\n  }\n  updatedAtDate {\n    ...FormattedDate\n  }\n}\n\nfragment useFormattedDate on Date {\n  __isDate: __typename\n  isoString\n}\n"
  }
};
})();

(node as any).hash = "3a2cd311bc2b1d555bcaeb469bf6012d";

export default node;
